/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-self-assign */
import React, { useEffect, useState, useContext } from "react";
import ReactDOM from "react-dom";
import { isBoolean } from "lodash";
import { FaDoorOpen, FaEdit, FaHome, FaInfoCircle, FaLock, FaSave, FaPlus, FaTrash, FaCheckCircle, FaExclamationTriangle, FaBuilding, FaUsers } from "react-icons/fa";
import { getConditionValue, translate } from "../../../../utils/Common";
import { useForm } from "react-hook-form/dist/index.ie11";
import { MdLaptopChromebook } from "react-icons/md";
import { usePlatforms } from "../../../../hooks/usePlatforms";
import ModalContent from "../../../../components/ModalContent";
import Spinner from "../../../../components/Spinner";
import { ToastContainer, useToast } from "../../../../components/common/Toast";
import BtnSync from '../../../../components/BtnSync';
import Button from '../../../../components/common/Button/Button';
import AuthContext from '../../../../contexts/auth';
import Tooltip from '../../../../components/Tooltip';
import Skeleton from '../../../../components/ui/Skeleton';
import { isModuleNetwork } from '../../../../config/providers';
import { isSameDoor, locateDoor, moveDoorInModule } from './doorOrder';
import DoorPositionPicker from './DoorPositionPicker';
import DeleteDoorConfirm from './DeleteDoorConfirm';
// import ProviderList from '../../../../components/ProviderList2';

const FormDoorsLocker = (props) => {
  const {createDoorsPlatforms, updateDoorPlatform, deleteDoorPlatform, assignCompanyToDoor, removeCompanyFromDoor, getCompaniesByDoor, getCompanies} = usePlatforms();
  const { selectDoor, setConfigLocker, configLocker, isLoadingDoor, isLoadingData, setIsLoadingDoor, setSelectDoor, setDoorsInBd, setEditModeDoors, doorsInBd, settingsLocker, setRefreshAssignments, pendingDoorOrderChanges, applyPendingDoorOrderChanges, discardPendingDoorOrderChanges, onDoorOrdersChange, reloadDoors, permissions, typeView, optionsProviders } = props;
    const { register, errors, handleSubmit, setValue, getValues } = useForm();
  const { toasts, showSuccess, showError, removeToast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const [modal, setModal] = useState({ title: '', body: '', footer: '' });
  const [showModal, setShowModal] = useState(false);
  const [originalConfigLocker, setOriginalConfigLocker] = useState(null);
  const [originalSelectDoor, setOriginalSelectDoor] = useState(null);
  const [openModeEdit, setOpenModeEdit] = useState(false);
  const [openModalCompleteModule, setOpenModalCompleteModule] = useState(false);
  const [assignedCompanies, setAssignedCompanies] = useState([]);
  const [isLoadingCompanies, setIsLoadingCompanies] = useState(false);
  const [companyFeedback, setCompanyFeedback] = useState(null); // { type: 'success' | 'error', text: string }
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companiesList, setCompaniesList] = useState([]);
  const [isLoadingCompaniesList, setIsLoadingCompaniesList] = useState(false);
  const [showCompanySelect, setShowCompanySelect] = useState(false);
  const [companySearchTerm, setCompanySearchTerm] = useState("");
  // columna que se le eligió a una puerta guardada: abre el selector de posición bajo el select
  const [positionPicker, setPositionPicker] = useState(null); // { columnId, collapsed }
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const userContext = useContext(AuthContext);
  const canManageCompanies = (userContext?.user?.RoleBli >= 4) || (userContext?.user?.roleId >= 5) || (userContext?.user?.IsAdmin);
  const canCreate = !!permissions?.canCreate;
  const canUpdate = !!permissions?.canUpdate;
  const canSyncDetails = !!permissions?.canSyncDetails;
  const canReorderDoors = !!permissions?.canReorderDoors;
  const canAssignDoorCompanies = !!permissions?.canAssignDoorCompanies;
  const canEditThisView = typeView === 'create' ? canCreate : canUpdate;
  const companySelectRef = React.useRef(null);
  const companyInputRef = React.useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0, width: 0 });

  // Helper function to get translated error message from API response
  const getDoorErrorMessage = (apiMessage) => {
    const translationKey = `dashboard.platforms.doors.errors.${apiMessage}`;
    const translatedMessage = translate(translationKey);
    
    // If translation exists, return it; otherwise return generic error.
    // translate() returns undefined for a missing key, so the old `!== key` check let an empty toast through
    if (translatedMessage && translatedMessage !== translationKey) {
      return translatedMessage;
    }
    
    // Fallback to generic error message
    return translate("dashboard.platforms.doors.errors.GENERIC");
  };

  const module = configLocker?.modules?.find(module => module?.moduleId === selectDoor?.moduleId);
  const comValue = module ? module.com : null;
  // en Multi-Vendor el COM depende del módulo de la puerta, no del locker
  const isNetwork = isModuleNetwork(module, settingsLocker?.IdFabricante, optionsProviders);

  // Cambiar de columna una puerta guardada corre a las demás del módulo: pide el permiso de reordenar
  // y el módulo completo, igual que arrastrarla en el Preview.
  const isSavedDoor = selectDoor?.boxitDoorId > 0;
  const isModuleComplete = !!module?.numDoors && (doorsInBd || []).filter(
    (door) => door.moduleId === module.moduleId && door.locationId === module.locationId
  ).length >= module.numDoors;
  const canMoveDoor = isSavedDoor && openModeEdit && canReorderDoors && isModuleComplete;
  const columnLockedReason = isSavedDoor && openModeEdit && !canMoveDoor
    ? translate(`dashboard.platforms.doors.position.locked.${canReorderDoors ? 'incomplete' : 'permission'}`)
    : null;
  // Eliminar una puerta guardada: solo US (el API de PA todavía no valida paquetes ni avisa al locker)
  const canDeleteDoor = !!permissions?.canDeleteDoors && isSavedDoor && !openModeEdit
    && localStorage.getItem("country") === "us";
  const doorHasPackages = (doorsInBd || []).some(
    (door) => Number(door.boxitDoorId) === Number(selectDoor?.boxitDoorId) && door.packageId
  );

  const columnOptions = module?.columns?.length
    ? module.columns.map((column) => ({ id: column.columnId, value: String(column.columnId) }))
    : [{ id: 1, value: "1" }, { id: 2, value: "2" }];

    const formFields = [
      { id: 'moduleNumber', label: translate("global.module"), required: false, colSize: 'col-span-12 md:col-span-6 lg:col-span-3', valueDefault: selectDoor?.moduleNumber, disabled: true },
      { id: 'doorNumber', label: ('# '+ translate("global.door")), required: true, colSize: 'col-span-12 md:col-span-6 lg:col-span-3', valueDefault: selectDoor?.doorNumber },
      { id: 'doorPort', label: translate("global.port"), required: false, colSize: 'col-span-12 md:col-span-6 lg:col-span-3', valueDefault: selectDoor?.doorPort || '', disabled: selectDoor?.boxitDoorId > 0 ? !openModeEdit : false, isHidden: selectDoor?.boxitDoorId <= 0 },
      { id: 'comPort', label: "COM", required: !isNetwork, colSize: 'col-span-12 md:col-span-6 lg:col-span-3', valueDefault: comValue ? comValue?.replace(/\D/g, '') : '', disabled: true, isHidden: isNetwork},
    ];
  
    const selectFields = [
      { id: 'columnNumber', label: translate("global.column") , required: false, options: columnOptions, colSize: 'col-span-12 md:col-span-6 lg:col-span-3', valueDefault: selectDoor?.columnModule, disabled: isSavedDoor ? !canMoveDoor : openModeEdit, hint: columnLockedReason},
      { id: 'dimension', label: translate("dashboard.platforms.dimension") , required: true, options: [{id: "S", value: "S"}, {id: "M", value: "M"}, {id: "L", value: "L"}, {id: "XL", value: "XL"} ], colSize: 'col-span-12 md:col-span-6', valueDefault: selectDoor?.dimension, disabled: false},
      { id: 'layer', label: translate("global.layer") , required: true, options: [{id: "H", value: "H - High"}, {id: "M", value: "M - Medium"}, {id: "L", value: "L - Low"}], colSize: 'col-span-12 md:col-span-6', valueDefault: selectDoor?.layer, disabled: false,  info: translate("global.representHeightFloor")},
      { id: 'isScreen', label: translate("global.controlDoor") , required: true, options: [ {id: 0, value: "No"}, {id: 1, value: "Yes"}], colSize: 'col-span-12 md:col-span-6', valueDefault: getConditionValue(selectDoor?.isScreen), disabled: false, icon: MdLaptopChromebook, info: translate("global.representControlDoor")},
      { id: 'isActive', label: translate("global.lock"), required: true, options: [{id: 1, value: "No"}, {id: 0, value: "Yes"}], colSize: 'col-span-12 md:col-span-6', valueDefault: getConditionValue(selectDoor?.isActive) , disabled: selectDoor?.isScreen===true ? true : false, icon: FaLock},
    ];
    
    const disabledInputsSelect = selectDoor?.boxitDoorId > 0 ? true : false;
    
    const handleIsDisabled = (valueInput) =>{

      if (valueInput) {
        return true
      } else {

        if (selectDoor?.boxitDoorId > 0) {

          if (openModeEdit) {
            return false;
          }
  
          return true;
          
        }
      }

    }

    const renderInputField = (props) => {
      const { id, label, required, colSize = "col-span-12", valueDefault = "",disabled, isHidden, Icon } = props;
      const isDisabled = handleIsDisabled(disabled);

      return (
        <div className={colSize}>
          {!isHidden && (
               <div className="flex justify-between items-center">
            
                 <label htmlFor={id} className="text-label-title">
                 {
                       Icon && <span className="mr-1"><Icon size={12} /></span>
                     }
      {label} {required && <span className="text-destructive">*</span>}
                 </label>
     
                 
             </div>
          )}
          
          <div className="mb-3 mb-2">
            
              <input
              id={id}
              name={id}
              defaultValue={valueDefault}
              value={valueDefault}
              disabled={isDisabled} 
              type={id === "doorNumber" ? "text" : id === "doorSequence" ? "number" : isHidden ? "hidden" : "text"} 
              ref={register({
                required: required && {
                  value: true,
                  message: translate('global.isRequerid'),
                },
              })}
              onChange={(e) => handleFieldChange(id, e.target.value)}
              className={`h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed form-control-md${errors[id] ? ' mb-2 border-destructive' : ''}`}
            />
            
            {errors[id] && <div className="mt-1 text-xs font-medium text-destructive">{errors[id].message}</div>}
          </div> 
        </div>
      );
    };
    
    const renderSelectField = (props) => {
      const { id, label, required, options, colSize = "col-span-12", valueDefault = "", isHidden, disabled, icon: Icon, info, hint } = props;
      const isDisabled = handleIsDisabled(disabled);
      
      return (
        <div className={colSize}>
          <div className="mb-3 mb-2">
            {!isHidden && (
              <>
                <div>
                  <label className="text-label-title" htmlFor={id}>
                    {Icon && <Icon />} {label} 
                    {required && <span className="text-destructive">*</span>}
                    {info && (
                      <Tooltip info={info} className="ml-1" />
                    )}
                  </label>
                </div>
                <div className="flex w-full items-stretch mb-3">
                  <select
                    id={id}
                    name={id}
                    defaultValue={valueDefault}
                    disabled={isDisabled}
                    onChange={(e) => (id === 'columnNumber' && isSavedDoor ? handleColumnChange(e.target.value) : handleFieldChange(id, e.target.value))}
                    ref={register({
                      required: required && {
                        value: true,
                        message: translate("global.isRequerid"),
                      },
                    })}
                    className={`h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed form-control-md${errors[id] ? " mb-2 border-destructive" : ""}`}
                  >
                    <option value="">Seleccione...</option>
                    {options.map((option, index) => (
                      <option key={index} value={option.id ?? index}>
                        {option?.value}
                      </option>
                    ))}
                  </select>
                </div>
                {errors[id] && <div className="mt-1 text-xs font-medium text-destructive">{errors[id].message}</div>}
                {hint && <p className="-mt-2 text-xs leading-4 text-muted-foreground">{hint}</p>}
              </>
            )}
          </div>
        </div>
      );
    };

    // Mueve la puerta guardada a `finalIndex` entre las demás puertas de `toColumnId`, con la misma
    // lógica que el arrastre del Preview, y deja pendientes las puertas que se corrieron.
    const moveSelectedDoorTo = (toColumnId, finalIndex) => {
      const from = locateDoor(module, selectDoor);
      if (!from) return;
      const toIndex = from.columnId === toColumnId && from.index <= finalIndex ? finalIndex + 1 : finalIndex;
      const { config, changedRealDoors } = moveDoorInModule(configLocker, {
        moduleId: selectDoor.moduleId,
        fromColumnId: from.columnId,
        fromIndex: from.index,
        toColumnId,
        toIndex,
      });
      if (config === configLocker) return;
      setConfigLocker(config);
      const movedDoor = config.modules
        .find((m) => m.moduleId === selectDoor.moduleId)
        ?.columns.flatMap((column) => column.doors)
        .find((door) => isSameDoor(door, selectDoor));
      if (movedDoor) setSelectDoor(movedDoor);
      if (changedRealDoors.length > 0) onDoorOrdersChange?.(changedRealDoors);
    };

    const handleDeleteDoor = async () => {
      if (!canDeleteDoor || doorHasPackages) return;
      setIsDeleting(true);
      try {
        const response = await deleteDoorPlatform(selectDoor.boxitDoorId, new AbortController().signal);
        if (response?.code === 200) {
          showSuccess(translate("dashboard.platforms.doors.delete.success"));
          setConfirmDelete(false);
          setSelectDoor(null);
          await reloadDoors?.();
        } else {
          showError(response?.message ? getDoorErrorMessage(response.message) : translate("dashboard.platforms.doors.errors.GENERIC"));
        }
      } catch (error) {
        showError(translate("dashboard.platforms.doors.errors.GENERIC"));
      } finally {
        setIsDeleting(false);
      }
    };

    // Al elegir otra columna la puerta entra al final y se abre el selector para ubicarla
    const handleColumnChange = (value) => {
      const toColumnId = Number(value);
      const toColumn = module?.columns?.find((column) => column.columnId === toColumnId);
      if (!toColumn) return;
      const othersInColumn = toColumn.doors.filter((door) => !isSameDoor(door, selectDoor)).length;
      moveSelectedDoorTo(toColumnId, othersInColumn);
      setPositionPicker({ columnId: toColumnId, collapsed: false });
    };

    const renderPositionPicker = () => {
      if (!positionPicker || !canMoveDoor) return null;
      const column = module?.columns?.find((c) => c.columnId === positionPicker.columnId);
      const position = column ? column.doors.findIndex((door) => isSameDoor(door, selectDoor)) : -1;
      if (position === -1) return null;
      const affectedCount = (pendingDoorOrderChanges?.[selectDoor.moduleId] || []).filter(
        (door) => !isSameDoor(door, selectDoor) && door.oldSequence !== door.doorSequence
      ).length;
      return (
        <DoorPositionPicker
          columnId={positionPicker.columnId}
          doors={column.doors.filter((door) => !isSameDoor(door, selectDoor))}
          movedDoor={selectDoor}
          position={position}
          onChange={(nextPosition) => moveSelectedDoorTo(positionPicker.columnId, nextPosition)}
          affectedCount={affectedCount}
          collapsed={positionPicker.collapsed}
          onCollapse={() => setPositionPicker((prev) => prev && { ...prev, collapsed: true })}
          onExpand={() => setPositionPicker((prev) => prev && { ...prev, collapsed: false })}
        />
      );
    };
    
    const handleFieldChange = (field, value) => { 
      const { moduleId, doorSequence } = selectDoor;
    
      setConfigLocker((prevConfig) => {
        const updatedConfig = JSON.parse(JSON.stringify(prevConfig));
    
        // Encuentra el módulo correspondiente
        const module = updatedConfig.modules.find((mod) => mod.moduleId === moduleId);
        if (!module) return prevConfig;
    
        // Encuentra la columna actual que contiene la puerta
        const currentColumn = module.columns.find((col) =>
          col.doors.some((door) => door.doorSequence === doorSequence)
        );
        if (!currentColumn) return prevConfig;
    
        const doorIndex = currentColumn.doors.findIndex(
          (door) => door.doorSequence === doorSequence
        );
        if (doorIndex === -1) return prevConfig;
    
        const door = currentColumn.doors[doorIndex];
    
        let updatedSelectDoor = { ...selectDoor }; // Hacemos una copia de selectDoor para actualizarlo correctamente
       
        if (field === "columnNumber" || field === "isScreen" || field === "isActive") {
           
        if (field === "columnNumber") {
          const newColumnNumber = parseInt(value, 10);
          if (currentColumn.columnId !== newColumnNumber) {
            const newColumn = module.columns.find(
              (col) => col.columnId === newColumnNumber
            );
    
            if (newColumn) {
              // Eliminar la puerta de la columna actual
              currentColumn.doors.splice(doorIndex, 1);
    
              // Buscar la primera secuencia disponible en la nueva columna
              if (door.boxitDoorId > 0) {
                // Si la puerta tiene boxitDoorId > 0, se le asigna una secuencia libre
                door.doorSequence = findAvailableSequenceInColumn(newColumn, module.endDoorNumber);
              }
    
              // Agregar la puerta a la nueva columna
              newColumn.doors.push({ ...door, columnModule: newColumnNumber });
    
              // Obtener el número inicial del módulo
              const startDoor = typeof module.startDoorNumber === "number"
                ? module.startDoorNumber
                : Number(module.startDoorNumber) || 1;
    
              // Recalcular doorNumber y doorSequence basándose en la posición física
              // doorNumber = startDoorNumber + doorSequence - 1
              let sequence = 0;
    
              module.columns.forEach((col) => {
                col.doors.forEach((door, index) => {
                  sequence++;
                  door.doorSequence = sequence;
                  
                  // Para borradores, calcular doorNumber basado en la posición
                  if (door.boxitDoorId === 0) {
                    door.doorNumber = startDoor + sequence - 1;
                  }
                  // Para puertas creadas, mantener su doorNumber original
                  
                  if (selectDoor.id === door.id) {
                    updatedSelectDoor = {
                      ...updatedSelectDoor,
                      columnModule: newColumnNumber,
                      doorNumber: door.doorNumber,
                      doorSequence: door.doorSequence,
                    };
    
                    setSelectDoor(updatedSelectDoor);
                  }
                });
              });
            }
          }
        } 

          if (field === "isScreen" ) {
            const newValue = getConditionValue(value);
            door[field] = newValue;
            
            // Si la puerta es una pantalla, desactivar la puerta osea bloquearla
            if (field === "isScreen" && value === "1") {
              door.isActive = false;
              setSelectDoor((prev) => ({
                ...prev,
               isScreen: true, isActive: false })
              );
            }else {
              door.isActive = true;
              setSelectDoor((prev) => ({
                ...prev,
                isScreen: false, isActive: true
              }));
            }

          } 
          
          if(field === "isActive" ){
            const newValue = getConditionValue(value);
            door[field] = newValue;
            door.isActive = newValue;
            setSelectDoor((prev) => ({
              ...prev,
              isActive: newValue })
            );
          }
        }else {
            // Convertir doorSequence a número si es necesario
            const fieldValue = field === "doorSequence" ? Number(value) : value;
            door[field] = fieldValue;
             // actualizar el setSelectDoor con los valores de la puerta
 setSelectDoor((prev) => ({
  ...prev,
  [field]: fieldValue
  }));
          }
        
    
        // Actualizar selectDoor aquí después de modificar la configuración
        return updatedConfig;
      });

    };
    
    const handleLoadCompanies = async () => {
      if (!selectDoor?.boxitDoorId) return;
      setIsLoadingCompanies(true);
      try {
        const abortController = new AbortController();
        const result = await getCompaniesByDoor(selectDoor.boxitDoorId, abortController.signal);
        // result may be array or object with payload
        const list = Array.isArray(result) ? result : (result?.payload || []);
        setAssignedCompanies(list);
        setCompanyFeedback(null);
      } catch (e) {
        setAssignedCompanies([]);
        setCompanyFeedback({ type: 'error', text: translate('dashboard.platforms.doorCompany.errors.LOAD_FAILED') });
        setTimeout(() => setCompanyFeedback(null), 4000);
      } finally {
        setIsLoadingCompanies(false);
      }
    };

    const handleLoadCompaniesList = async () => {
      setIsLoadingCompaniesList(true);
      try {
        const abortController = new AbortController();
        const result = await getCompanies(abortController.signal);
        const list = Array.isArray(result) ? result : (result?.payload || result?.data || []);
        setCompaniesList(list);
      } catch (e) {
        setCompaniesList([]);
        console.error('Error loading companies list:', e);
      } finally {
        setIsLoadingCompaniesList(false);
      }
    };

    const handleCompanySelect = (company) => {
      setSelectedCompany(company);
      setShowCompanySelect(false);
      setCompanySearchTerm("");
    };

    const filteredCompanies = companiesList.filter(company =>
      `${company.companyName}`
        .toLowerCase()
        .includes(companySearchTerm.toLowerCase())
    );


    const handleAddCompany = async () => {
      const companyCodeToSend = selectedCompany?.companyCode;
      if (!companyCodeToSend || !selectDoor?.boxitDoorId) return;
      if (!canAssignDoorCompanies) return;
      if (!canManageCompanies || !openModeEdit) return;
      if (assignedCompanies && assignedCompanies.length >= 1) return;
      setIsLoadingCompanies(true);
      try {
        const abortController = new AbortController();
        const res = await assignCompanyToDoor(selectDoor.boxitDoorId, companyCodeToSend, abortController.signal);
        if (res?.code === 200) {
          await handleLoadCompanies();
          setSelectedCompany(null);
          setCompanyFeedback({ type: 'success', text: translate('dashboard.platforms.doorCompany.success.ASSIGNED') });
          setTimeout(() => setCompanyFeedback(null), 4000);
          // Refrescar asignaciones en el preview
          setRefreshAssignments(prev => prev + 1);
        } else {
          const key = res?.message;
          let text = translate('dashboard.platforms.doorCompany.errors.GENERIC');
          if (key === 'DOOR_DOESNT_EXISTS') text = translate('dashboard.platforms.doorCompany.errors.DOOR_DOESNT_EXISTS');
          else if (key === 'COMPANY_DOESNT_EXISTS') text = translate('dashboard.platforms.doorCompany.errors.COMPANY_DOESNT_EXISTS');
          else if (key === 'COMPANY_ALREADY_WAS_ASSIGNED') text = translate('dashboard.platforms.doorCompany.errors.COMPANY_ALREADY_WAS_ASSIGNED');
          setCompanyFeedback({ type: 'error', text });
          setTimeout(() => setCompanyFeedback(null), 5000);
        }
      } finally {
        setIsLoadingCompanies(false);
      }
    };

    const handleRemoveCompany = async (companyCode) => {
      if (!companyCode || !selectDoor?.boxitDoorId) return;
      if (!canAssignDoorCompanies) return;
      if (!canManageCompanies || !openModeEdit) return;
      setIsLoadingCompanies(true);
      try {
        const abortController = new AbortController();
        const res = await removeCompanyFromDoor(selectDoor.boxitDoorId, companyCode, abortController.signal);
        if (res?.code === 200) {
          await handleLoadCompanies();
          setCompanyFeedback({ type: 'success', text: translate('dashboard.platforms.doorCompany.success.REMOVED') });
          setTimeout(() => setCompanyFeedback(null), 4000);
          // Refrescar asignaciones en el preview
          setRefreshAssignments(prev => prev + 1);
        } else {
          const key = res?.message;
          let text = translate('dashboard.platforms.doorCompany.errors.GENERIC');
          if (key === 'DOOR_DOESNT_EXISTS') text = translate('dashboard.platforms.doorCompany.errors.DOOR_DOESNT_EXISTS');
          else if (key === 'COMPANY_DOESNT_EXISTS') text = translate('dashboard.platforms.doorCompany.errors.COMPANY_DOESNT_EXISTS');
          else if (key === 'COMPANY_ALREADY_WAS_ASSIGNED') text = translate('dashboard.platforms.doorCompany.errors.COMPANY_ALREADY_WAS_ASSIGNED');
          setCompanyFeedback({ type: 'error', text });
          setTimeout(() => setCompanyFeedback(null), 5000);
        }
      } finally {
        setIsLoadingCompanies(false);
      }
    };
    // Función para encontrar la secuencia disponible en la nueva columna
    const findAvailableSequenceInColumn = (column, endDoor) => {
      // Buscar la primera secuencia disponible para las puertas con boxitDoorId > 0
      let sequence = 1;
      
      // Comprobamos que la secuencia no esté tomada y que no se pase del límite 'endDoor'
      const isSequenceTaken = (sequence) => column.doors.some((door) => door.doorSequence === sequence && door.boxitDoorId > 0);
    
      while (isSequenceTaken(sequence) && sequence <= endDoor) {
        sequence++;  // Incrementamos la secuencia hasta encontrar una libre
      }
    
      // Si la secuencia excede el límite de 'endDoor', limitamos la secuencia al valor de 'endDoor'
      if (sequence > endDoor) {
        return endDoor;
      }
    
      return sequence;
    };

    const handleSaveDoor = async (data) => {
      setIsLoading(true);
      setIsLoadingDoor(true);
      const abortController = new AbortController();
      
      const doorSequenceOrder = Number(selectDoor.doorSequence);
      const dataToSend = {
        ...selectDoor,
        doorId: selectDoor.boxitDoorId,
        isActive: getConditionValue(data.isActive),
        locationId: selectDoor.locationId,
        moduleId: selectDoor.moduleId,
        doorNumber: data.doorNumber,
        doorSequence: (doorSequenceOrder != null && !Number.isNaN(doorSequenceOrder)) ? doorSequenceOrder : 1,
        dimension: data.dimension,
        layer: data.layer,
        isScreen: getConditionValue(data.isScreen),
        columnNumber: Number(data.columnNumber),
        isUpdate:  false,
        isAvailable: true,
        comPort: "COM" + comValue?.replace(/\D/g, ''),
        doorPort: data.doorPort,
      }      

      const response = await createDoorsPlatforms(dataToSend, abortController.signal); 

      if (response.code === 200) {
        setSelectDoor(null);
        setDoorsInBd((prevDoors) => {
          const updatedDoors = [...prevDoors, {...dataToSend, boxitDoorId: response.boxitDoorId, doorId: response.boxitDoorId, doorPort: response.doorPort}];
          return updatedDoors;
        });

        // Actualizar el boxitDoorId de la puerta en configLocker
        setConfigLocker((prevConfig) => {
          const updatedConfig = JSON.parse(JSON.stringify(prevConfig));
          const module = updatedConfig.modules.find((mod) => mod.moduleId === dataToSend.moduleId);
          if (!module) return prevConfig;
  
          const column = module.columns.find((col) => col.columnId === dataToSend.columnNumber);
          if (!column) return prevConfig;
          const door = column.doors.find((door) => door.doorSequence === dataToSend.doorSequence);
          if (!door) return prevConfig;
          door.boxitDoorId = response.boxitDoorId;
          // Asignar el port generado por el API a la puerta recién creada
          if (response.doorPort) {
            door.doorPort = response.doorPort;
          }
          return updatedConfig;
        });

        const { moduleId, doorSequence } = selectDoor;
        setConfigLocker((prevConfig) => {
          const updatedConfig = JSON.parse(JSON.stringify(prevConfig));
          const module = updatedConfig.modules.find((mod) => mod.moduleId === moduleId);
  
          if (!module) return prevConfig;
  
          // Encuentra la columna actual que contiene la puerta
          const currentColumn = module.columns.find((col) =>
            col.doors.some((door) => door.doorSequence === doorSequence)
          );
  
          if (!currentColumn) return prevConfig;
          
          const doorIndex = currentColumn.doors.findIndex(
            (door) => door.doorSequence === doorSequence
          );
  
          if (doorIndex === -1) return prevConfig;
  
          // Intenta seleccionar la siguiente puerta en la misma columna
          let nextDoor = currentColumn.doors[doorIndex + 1];
  
          // Si no hay más puertas en la columna, pasa a la primera puerta de la siguiente columna
          if (!nextDoor) {
            const currentColumnIndex = module.columns.indexOf(currentColumn);
            const nextColumn = module.columns[currentColumnIndex + 1];
  
            if (nextColumn && nextColumn.doors.length > 0) {
              nextDoor = nextColumn.doors[0];
            }
          }
  
          if (nextDoor) {
            // Actualizamos la puerta seleccionada
            setSelectDoor(nextDoor);
          }
  
          return updatedConfig;
        });

        setIsLoadingDoor(false);
        showSuccess(translate("global.createSuccessDoor"));
        setOpenModalCompleteModule(true);
      }else{
         // Show specific error message from API response if available
         const errorMessage = response?.message 
           ? getDoorErrorMessage(response.message)
           : translate("dashboard.platforms.doors.errors.GENERIC");
         showError(errorMessage);
         setIsLoadingDoor(false);
      }
      setIsLoading(false);
    }
 // Función para calcular el porcentaje de ocupación de un módulo
 const calculateModuleProgress = (module) => {
  const doorsInModule = doorsInBd.filter(
    (door) => door.moduleId === module.moduleId && door.locationId === module.locationId
  );
  const doorsInDatabase = doorsInModule.length;
  const totalDoorsInModule = module.numDoors;
  const doorsInDatabasePercentage = (doorsInDatabase / totalDoorsInModule) * 100;
  return Math.min(doorsInDatabasePercentage, 100).toFixed(0);
};

    const verifyCompleteModules = () => {
              const allModulesComplete = configLocker.modules.every(
                (module) => calculateModuleProgress(module) === "100"
              );              
              
              if (allModulesComplete) {
              
                setModal({
                  title: translate( "global.alert.ready"),
                  body: `${translate("global.allModulesComplete")}. ID ${translate("global.locker")}: ${settingsLocker?.IdPlataforma}`,
                  footer: <div style={{ display: "flex", gap: "10px" }}>
                      <Button variant="ghostOutline" size="sm" onClick={() => setShowModal(false)}>{translate('global.return')}</Button>
                      <Button variant="primary" size="sm" leftIcon={<FaHome />} onClick={() => window.location.href = `/dashboard/platforms/general`}>{translate("global.goToHome")}</Button>
                  </div>,
                });
                setShowModal(true);
              }

              setOpenModalCompleteModule(false);
    }
    
    const toggleEditMode = () => {
      if (!canUpdate) return;
      setEditModeDoors((prevMode) => !prevMode); // Alterna entre true y false
      setOpenModeEdit((prevMode) => !prevMode);
    };    

    const handleUpdateDoor = async () => {
      if (!canUpdate) return;
      setIsLoading(true);
      setIsLoadingDoor(true);
      const abortController = new AbortController();
      const formDoorPort = getValues('doorPort');
      const dataToSend = {
        ...selectDoor,
        doorId: selectDoor.boxitDoorId,
        locationId: selectDoor.locationId,
        moduleId: selectDoor.moduleId,
        doorNumber: String(selectDoor.doorNumber),
        doorSequence: Number(selectDoor.doorSequence),
        doorPort: formDoorPort != null && formDoorPort !== '' ? String(formDoorPort).replace(/\D/g, '') || formDoorPort : selectDoor?.doorPort,
        dimension: selectDoor.dimension,
        layer: selectDoor.layer,
        isLocked: selectDoor.isLocked,
        isScreen: isBoolean(selectDoor.isScreen) ? selectDoor.isScreen : getConditionValue(selectDoor.isScreen),
        columnNumber: Number(selectDoor.columnModule),
        isActive: isBoolean(selectDoor.isActive) ? selectDoor.isActive : getConditionValue(selectDoor.isActive),
        isAvailable: true,
        isUpdate: true,
        comPort: "COM" + selectDoor?.comPort?.replace(/\D/g, '')
      }      

      const response = await updateDoorPlatform(dataToSend, abortController.signal);

      setIsLoading(false);
      if (response.code === 200) {
        // Si hay cambios pendientes de orden de puertas en el mismo módulo, aplicarlos ahora
        if (!canReorderDoors && pendingDoorOrderChanges?.[selectDoor.moduleId]) {
          // sin permiso el orden no se guarda: se descarta para que el error no quede pegado hasta recargar
          showError(translate("dashboard.clients.formSearch.NOT_ACCESS"));
          await discardPendingDoorOrderChanges?.(selectDoor.moduleId, { reload: true });
        } else if (applyPendingDoorOrderChanges && selectDoor?.moduleId && pendingDoorOrderChanges?.[selectDoor.moduleId]) {
          const result = await applyPendingDoorOrderChanges(selectDoor.moduleId);
          if (result.success) {
            showSuccess(translate("global.updateSuccessDoor"));
          } else {
            showError(translate("dashboard.platforms.doors.errors.ORDER_UPDATE_FAILED"));
          }
        } else {
          showSuccess(translate("global.updateSuccessDoor"));
        }
        setOpenModeEdit(false);
        setEditModeDoors(false); /* Quitar espacios de reordenar al guardar */
        setPositionPicker(null);
      }else{
        // Show specific error message from API response if available
        const errorMessage = response?.message 
          ? getDoorErrorMessage(response.message)
          : translate("dashboard.platforms.doors.errors.GENERIC");
        showError(errorMessage);
      }

      setIsLoadingDoor(false);
    };
      
    const handleCancel = () => {
      // Restablece a los valores originales
      if (originalConfigLocker && originalSelectDoor) {
        setConfigLocker(JSON.parse(JSON.stringify(originalConfigLocker)));
        setSelectDoor(JSON.parse(JSON.stringify(originalSelectDoor)));
      }
      // el orden arrastrado se descarta junto con lo demás
      if (selectDoor?.moduleId) discardPendingDoorOrderChanges?.(selectDoor.moduleId);
      setPositionPicker(null);
      setOpenModeEdit(false); // Salir de modo edición
      setEditModeDoors(false); // Quitar espacios de reordenar
    };
    
    useEffect(() => {
      if (selectDoor) {
        
        // Actualiza los valores del formulario cuando selectDoor cambia
        setValue("moduleNumber", selectDoor.moduleNumber || "");
        setValue("doorNumber", selectDoor.doorNumber || "");
        setValue("columnNumber", selectDoor.columnModule || "");
        setValue("dimension", selectDoor.dimension || "");
        setValue("layer", selectDoor.layer || "");
        setValue("isScreen", getConditionValue(selectDoor.isScreen || false));
      setValue("isActive", getConditionValue(selectDoor.isActive || false));
        setValue("doorSequence", selectDoor.doorSequence || "");
        setValue("doorPort", selectDoor.doorPort ?? "");
        handleLoadCompanies();
      }
    }, [selectDoor, setValue]);

    // el selector es de la puerta que se está editando
    useEffect(() => {
      setPositionPicker(null);
      setConfirmDelete(false);
    }, [selectDoor?.boxitDoorId, selectDoor?.id, openModeEdit]);

    useEffect(() => {
      if (openModeEdit) {
        // Guarda los estados originales al entrar en modo edición
        setOriginalConfigLocker(JSON.parse(JSON.stringify(configLocker)));
        setOriginalSelectDoor(JSON.parse(JSON.stringify(selectDoor)));
      }
    }, [openModeEdit]);

    useEffect(() => {
    if(openModalCompleteModule){
      verifyCompleteModules();  
    }
    }, [openModalCompleteModule]);

    useEffect(() => {
      handleLoadCompaniesList();
    }, []);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (companySelectRef.current && !companySelectRef.current.contains(event.target) &&
            !event.target.closest('.door-company-dropdown-portal')) {
          setShowCompanySelect(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    // Update dropdown position for Portal (avoids z-index/overflow clipping)
    useEffect(() => {
      if (showCompanySelect && companySelectRef.current) {
        const rect = companySelectRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom,
          left: rect.left,
          width: rect.width,
        });
      }
    }, [showCompanySelect, companySearchTerm, filteredCompanies.length]);

    // Focus input when dropdown opens (single-input combobox UX)
    useEffect(() => {
      if (showCompanySelect && companyInputRef.current) {
        companyInputRef.current.focus();
      }
    }, [showCompanySelect]);
    

    
  return (
    <form className="cardInternal" onSubmit={handleSubmit(handleSaveDoor)}>
      <div className="cardInternal-header">
        <div className="cardInternal-title">
          <span className="mr-1">
            <FaDoorOpen size={18} />
          </span>
          {translate("global.doors", "capital")}
        </div>
        <div>
          {selectDoor && (
            <div style={{display:"flex",alignItems:"center", gap:'15px'}}>

            {canSyncDetails && selectDoor?.boxitDoorId > 0 && <BtnSync mode="door" doorId={selectDoor?.boxitDoorId}/> }

<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center' }}>
            {(!openModeEdit) ? (
              selectDoor?.boxitDoorId > 0 && (
                <>
                  {canDeleteDoor && !confirmDelete && (
                    <Button variant="ghostOutline" size="sm" leftIcon={<FaTrash />} onClick={() => setConfirmDelete(true)} className="text-destructive">
                      {translate("dashboard.platforms.doors.delete.button")}
                    </Button>
                  )}
                  {canUpdate && (
                    <Button variant="primary" size="sm" leftIcon={<FaEdit />} onClick={() => toggleEditMode()}>
                      {translate("global.edit")}
                    </Button>
                  )}
                  <Button variant="ghostOutline" size="sm" onClick={() => setSelectDoor(null)}>
                    {translate("global.close")}
                  </Button>
                </>
              )
            ) : (
              <>
                <Button variant="ghostOutline" size="sm" onClick={handleCancel}>
                  {translate("global.cancel")}
                </Button>
                <Button variant="primary" size="sm" leftIcon={<FaSave />} loading={isLoading} onClick={handleUpdateDoor} type="button" disabled={!canUpdate}>
                  {translate("global.save")}
                </Button>
              </>
            )}

            {/* Botones para puerta nueva/borrador: solo cuando no está en modo edición de una existente */}
            {!disabledInputsSelect && !openModeEdit && selectDoor?.boxitDoorId <= 0 && (
              <>
                <Button variant="ghostOutline" size="sm" onClick={() => setSelectDoor(null)} type="button">
                  {translate("global.close")}
                </Button>
                <Button variant="primary" size="sm" leftIcon={<FaPlus />} loading={isLoading} type="submit" disabled={isLoading || !canCreate}>
                  {translate("global.create")}
                </Button>
              </>
            )}
          </div>
          
        </div>
          )}
        
        </div>
      </div>
      <div className="cardInternal-body">
        {(isLoadingData || isLoadingDoor) && !selectDoor ? (
          <div className="flex flex-wrap">
            <div className="w-full">
              <div className="messageAlert">
                <div className="flex items-center justify-center" style={{ minHeight: '200px', flexDirection: 'column', gap: '10px' }}>
                  <Skeleton width={200} height={20} />
                  <Skeleton width={300} height={16} />
                </div>
              </div>
            </div>
          </div>
        ) : selectDoor ? (
          <div className="grid grid-cols-12 gap-x-4">
            {confirmDelete && canDeleteDoor && (
              <DeleteDoorConfirm
                doorNumber={selectDoor?.doorNumber}
                hasPackages={doorHasPackages}
                isDeleting={isDeleting}
                onCancel={() => setConfirmDelete(false)}
                onConfirm={handleDeleteDoor}
              />
            )}
            {/* Render Input Fields */}
            {formFields.map((field, index) => renderInputField({ ...field, key: index }))}

            {/* Render Select Fields */}
            {selectFields.map((field) => (
              <React.Fragment key={field.id}>
                {renderSelectField(field)}
                {field.id === 'columnNumber' && renderPositionPicker()}
              </React.Fragment>
            ))}


            {/* Companies Assignment */}
            {selectDoor?.boxitDoorId > 0 && canAssignDoorCompanies && canManageCompanies && (
              <div className="w-full">
                <div className="p-3 door-company-card">
                  <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        <FaUsers className="mr-2 door-company-title-icon" />
                        <div className="door-company-title-text">{translate("global.business")} {translate("global.assigned")}</div>
                      </div>
                  </div>

                  {(assignedCompanies?.length ?? 0) === 0 && (
                    <div className="flex door-company-search-wrapper" ref={companySelectRef}>
                      <div className="door-company-search-input-wrapper door-company-combobox">
                        <div className="flex w-full items-stretch">
                          <div className="flex items-center">
                            <span className="flex items-center px-3 text-muted-foreground door-company-input-addon">
                              <FaBuilding size={16} />
                            </span>
                          </div>
                          <input
                            ref={companyInputRef}
                            type="text"
                            className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed door-company-input"
                            placeholder={translate("global.search") + " " + translate("global.business").toLowerCase() + "..."}
                            value={showCompanySelect ? companySearchTerm : (selectedCompany ? `${selectedCompany.companyName || ""}` : "")}
                            readOnly={!showCompanySelect && selectedCompany}
                            onClick={() => canManageCompanies && openModeEdit && setShowCompanySelect(true)}
                            onFocus={() => canManageCompanies && openModeEdit && setShowCompanySelect(true)}
                            onChange={(e) => {
                              if (canManageCompanies && openModeEdit) {
                                setCompanySearchTerm(e.target.value);
                                setSelectedCompany(null);
                                setShowCompanySelect(true);
                              }
                            }}
                            disabled={!canManageCompanies || !openModeEdit}
                            aria-label={translate("global.search") + " " + translate("global.business").toLowerCase()}
                          />
                        </div>
                      </div>
                      {showCompanySelect && canManageCompanies && openModeEdit && ReactDOM.createPortal(
                        <div
                          className="door-company-dropdown door-company-dropdown-portal border rounded-md shadow-sm"
                          style={{
                            position: 'fixed',
                            top: dropdownPosition.top + 4,
                            left: dropdownPosition.left,
                            width: dropdownPosition.width,
                            zIndex: 10000,
                          }}
                        >
                          <div style={{ maxHeight: '180px', overflowY: 'auto' }}>
                            {isLoadingCompaniesList ? (
                              <div className="p-3 text-center">
                                <Spinner type={1} size={15} />
                              </div>
                            ) : filteredCompanies.length > 0 ? (
                              filteredCompanies.map((company) => (
                                <div
                                  key={company.companyCode || ""}
                                  className="p-2 border-bottom cursor-pointer hover:text-secondary door-company-dropdown-item"
                                  onClick={() => handleCompanySelect(company)}
                                  onMouseDown={(e) => e.preventDefault()}
                                  role="option"
                                  aria-selected={selectedCompany?.companyCode === company.companyCode}
                                >
                                  <div className="font-semibold door-company-dropdown-item-text">
                                    {company.companyName || ""}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="p-3 text-muted-foreground text-center door-company-dropdown-empty">
                                {translate("components.showItems.results.NOT_RESULTS")}
                              </div>
                            )}
                          </div>
                        </div>,
                        document.body
                      )}
                      <Button type="button" variant="primary" size="sm" className="door-company-add-btn" leftIcon={<FaPlus />} loading={isLoadingCompanies} onClick={() => handleAddCompany()} disabled={!canManageCompanies || !openModeEdit || !selectedCompany}>
                        {translate("global.add")}
                      </Button>
                    </div>
                  )}

                  {companyFeedback && (
                    <div className={`mt-2 door-company-feedback ${companyFeedback.type === 'success' ? 'door-company-feedback-success' : 'door-company-feedback-error'}`}>
                      {companyFeedback.type === 'success' ? (
                        <FaCheckCircle className="mr-1" />
                      ) : (
                        <FaExclamationTriangle className="mr-1" />
                      )}
                      <span>{companyFeedback.text}</span>
                    </div>
                  )}

                  {/* {(!canManageCompanies || !openModeEdit) && (
                    <div className="flex items-center text-muted-foreground mt-2" style={{fontSize:'12px'}}>
                      <FaInfoCircle className="mr-1" style={{fontSize:'10px'}} />
                      <span>{!canManageCompanies ? 'Sin permisos' : 'Activa edición'}</span>
                    </div>
                  )} */}

                  <div className="mt-3">
                    {isLoadingCompanies ? (
                      <Spinner type={20} />
                    ) : assignedCompanies && assignedCompanies.length > 0 ? (
                      <div className="flex flex-wrap door-company-chips">
                        {assignedCompanies.map((c, idx) => (
                          <div key={`company-chip-${idx}`} className="flex items-center door-company-chip">
                            <span className="mr-2 door-company-chip-label">
                              {(c?.NombreEmpresa || c?.companyName || c?.name || 'Empresa')}
                            </span>
                            <Button 
                              type="button" 
                              variant="ghost" 
                              size="sm"
                              onClick={() => handleRemoveCompany(c?.coduser || c?.companyCode)} 
                              disabled={!canManageCompanies || !openModeEdit}
                              className={`door-company-chip-remove ${(!canManageCompanies || !openModeEdit) ? 'door-company-chip-remove-disabled' : ''}`}
                            >
                              <FaTrash />
                            </Button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex items-center text-muted-foreground" style={{fontSize:12}}>
                        <FaBuilding className="mr-1" style={{fontSize:'10px'}} />
                        <span>{translate("global.noCompanyAssigned")}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="messageAlert">
            {translate("global.messageSelectDoorInfo")}
          </div>
        )}
      </div>
      <ModalContent
                        title={modal.title}
                        body={modal.body}
                        footer={modal.footer}
                        isOpenModal={showModal}
                        onHide={() => setShowModal(false)}
                />
      {/* Toast Notifications */}
      <ToastContainer toasts={toasts} removeToast={removeToast} />
    </form>
  );
};

export default FormDoorsLocker;
